export const SELECTORS = {
  CONTAINER: 'js-images-visibility-container',
  ITEM: 'js-images-visibility-item'
};

export const ROTATION_INTERVAL_MS = 2000;
